'use client';
import { Fragment } from 'react';
import Portal from '../portal/index.mjs';
import { jsx } from 'react/jsx-runtime';

// src/components/portal-or-fragment/index.tsx
var PortalOrFragment = ({
  disablePortal,
  children,
  ...props
}) => {
  return disablePortal ? /* @__PURE__ */ jsx(Fragment, { children }) : /* @__PURE__ */ jsx(Portal, { ...props, children });
};
var portal_or_fragment_default = PortalOrFragment;

export { portal_or_fragment_default as default };
